import React from 'react';
import Styles from './styles.module.css';
import DefaultTitle from '../title';
import DefaultDesc from '../desc';

type DefaultSelect2Props = {
  error1: boolean,
  error2: boolean,
  title: string,
  required: Boolean,
  value1: string,
  setValue1: (value: string) => void;
  value2: string,
  setValue2: (value: string) => void;
  list1: string[],
  list2: string[],
  desc?: string;
};

const DefaultSelect2: React.FC<DefaultSelect2Props> = ({ error1, error2, title, value1, setValue1, value2, setValue2, list1, list2, desc }) => {

  return (
    <>
    <DefaultTitle
      title={title}
    />
    <div className={Styles.select}>
      <select className={Styles.select} value={value1} onChange={(e) => setValue1(e.target.value)}
        style={error1 ? { border: ".5px solid #E31C5F", color: "#E31C5F" } : {}}>
        {list1.map((data, index) =>
          <option value={data === '未選択' ? '' : data} key={index}>{data}</option>
        )}
      </select>
      <p>〜</p>
      <select className={Styles.select} value={value2} onChange={(e) => setValue2(e.target.value)}
        style={error2 ? { border: ".5px solid #E31C5F", color: "#E31C5F" } : {}}>
        {list2.map((data, index) =>
          <option value={data === '未選択' ? '' : data} key={index}>{data}</option>
        )}
      </select>
    </div>
    {desc && ( <DefaultDesc text={desc} /> )}
    </>
  );
}

export default DefaultSelect2;
